import React, { useState } from "react";

import API from "../../../services/api";

import {

    Lock,

    Eye,

    EyeOff,

    KeyRound

} from "lucide-react";

import "./ChangePassword.css";

function ChangePassword() {

    const [form, setForm] = useState({

        currentPassword: "",

        newPassword: "",

        confirmPassword: "",

    });

    const [showCurrent, setShowCurrent] = useState(false);

    const [showNew, setShowNew] = useState(false);

    const [showConfirm, setShowConfirm] = useState(false);

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {

        setForm({

            ...form,

            [e.target.name]: e.target.value,

        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (

            form.newPassword !==

            form.confirmPassword

        ) {

            alert(

                "Passwords do not match."

            );

            return;

        }

        try {

            setLoading(true);

            const response = await API.put(

                "/delivery/change-password",

                form

            );

            alert(response.data.message);

            setForm({

                currentPassword: "",

                newPassword: "",

                confirmPassword: "",

            });

        }

        catch (error) {

            alert(

                error.response?.data?.message ||

                "Unable to change password."

            );

        }

        finally {

            setLoading(false);

        }

    };

    return (

        <div className="change-password-page">

            <form

                className="password-card"

                onSubmit={handleSubmit}

            >

                <h1>

                    Change Password

                </h1>

                <p>

                    Update your account password.

                </p>

                {/* Current Password */}

                <div className="password-group">

                    <label>

                        <Lock size={16}/>

                        Current Password

                    </label>

                    <div className="password-input">

                        <input

                            type={

                                showCurrent

                                    ? "text"

                                    : "password"

                            }

                            name="currentPassword"

                            value={form.currentPassword}

                            onChange={handleChange}

                        />

                        <button

                            type="button"

                            onClick={()=>

                                setShowCurrent(

                                    !showCurrent

                                )

                            }

                        >

                            {

                                showCurrent

                                ?

                                <EyeOff size={18}/>

                                :

                                <Eye size={18}/>

                            }

                        </button>

                    </div>

                </div>

                {/* New Password */}

                <div className="password-group">

                    <label>

                        <KeyRound size={16}/>

                        New Password

                    </label>

                    <div className="password-input">

                        <input

                            type={

                                showNew

                                    ? "text"

                                    : "password"

                            }

                            name="newPassword"

                            value={form.newPassword}

                            onChange={handleChange}

                        />

                        <button

                            type="button"

                            onClick={()=>

                                setShowNew(

                                    !showNew

                                )

                            }

                        >

                            {

                                showNew

                                ?

                                <EyeOff size={18}/>

                                :

                                <Eye size={18}/>

                            }

                        </button>

                    </div>

                </div>

                {/* Confirm Password */}

                <div className="password-group">

                    <label>

                        <Lock size={16}/>

                        Confirm Password

                    </label>

                    <div className="password-input">

                        <input

                            type={

                                showConfirm

                                    ? "text"

                                    : "password"

                            }

                            name="confirmPassword"

                            value={form.confirmPassword}

                            onChange={handleChange}

                        />

                        <button

                            type="button"

                            onClick={()=>

                                setShowConfirm(

                                    !showConfirm

                                )

                            }

                        >

                            {

                                showConfirm

                                ?

                                <EyeOff size={18}/>

                                :

                                <Eye size={18}/>

                            }

                        </button>

                    </div>

                </div>

                <button

                    className="change-password-btn"

                    disabled={loading}

                >

                    {

                        loading

                        ?

                        "Updating..."

                        :

                        "Update Password"

                    }

                </button>

            </form>

        </div>

    );

}

export default ChangePassword;